import { Component, OnInit } from '@angular/core';
import { SessionService } from 'src/app/services/session.service';

@Component({
  selector: 'loyale-clear-cache',
  templateUrl: './clear.component.html',
  standalone: false
})
export class ClearCacheComponent implements OnInit {
  constructor(private sessionService: SessionService) { }

  ngOnInit(): void {
    localStorage.clear();
    sessionStorage.clear();
    this.sessionService.signOut();
  }
}
